import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import gigJobPartiesMixin from './gigJobPartiesMixin'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [gigJobPartiesMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
    }),
    hasReviewed() {
      if (this?.isCompleted) {
        return this.isEmployer ? this.application.customerLeftReview : this.application.freelancerLeftReview
      }

      return false
    },
    hasLeaveReview() {
      if (!this.isCompleted) return false

      return this.isEmployer ? !this.application.customerLeftReview : !this.application.freelancerLeftReview
    },
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
    }),
    ...mapMutations({
      updateApplication: 'gigChat/updateApplication',
    }),
    leaveReview() {
      this.openModal({
        component: 'lx-lazy-modal',
        props: {
          factory: import(/* webpackChunkName: "job-modals" */ '@/modals/LeaveFeedback/LeaveFeedback.vue'),
          title: 'Leave a review',
          props: {
            fromFreelancer: this.isFreelancer,
            gigId: this.application.job.id,
            name: this.application.gig.name,
            profile: this.isFreelancer ? this.application.customer : this.application.freelancer,
            onSuccess: this.onSuccessLeavingReview,
          },
        },
      })
    },
    onSuccessLeavingReview() {
      if (this.isEmployer) {
        this.updateApplication({ id: this.application.id, customerLeftReview: true })
      } else {
        this.updateApplication({ id: this.application.id, freelancerLeftReview: true })
      }
    },
  },
})
